import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { confirmCountries } from '../actions/countries';
import CountryRelations from '../components/country-relations';
export default connect(state => {
  return {
    confirmedCountries: state.countries.confirmCountries
  };
}, dispatch => bindActionCreators({
  confirmCountries
}, dispatch))(CountryRelations);